import { ProductType } from 'cart-model';
import Screen from '../Screen';

export const getDynamicTitleKey = (
  productType?: ProductType,
  screenType: 'choose-investment' | 'set-amounts' = 'choose-investment'
): string => {
  const defaultKey = screenType === 'choose-investment'
    ? Screen.CHOOSE_INVESTMENT_AMOUNT.code
    : Screen.SET_AMOUNTS_PER_FUND.code;
  if (!productType) {
    return defaultKey;
  }
  const prefix = screenType === 'choose-investment'
    ? 'choose-investment-amount'
    : 'set-amounts';
  const suffix = {
    [ProductType.ike]: 'ike',
    [ProductType.ikze]: 'ikze',
    [ProductType.funds]: 'funds'
  }[productType];
  return suffix ? `${prefix}-${suffix}` : defaultKey;
};
